import { Modal } from "antd";
import React, { Dispatch } from "react";
import { Translate, TranslateFunction } from "react-localize-redux";
import { useDispatch, useSelector } from "react-redux";
import { ModalErrorIcon } from "../../assets/Icons";
import { SetChromeExtensionMissingVisibleAction } from "../../interfaces/store/actions/job";
import { setChromeExtensionMissingVisible } from "../../store/actions/job";
import { selectIsChromeExtensionMissingVisible } from "../../store/selectors/job";
import { selectCtWebExtensionUrl } from "../../store/selectors/serviceProperties";
import { selectTranslate } from "../../store/selectors/translate";
import { CtModalHeader } from "./CtModalHeader";
import "./CtModals.scss";

const i18nPath: string = "components.ChromeExtensionMissingModal.ChromeExtensionMissingModal";
const i18nTitle: string = `${i18nPath}.title.text`;
const i18nPleaseVisit: string = `${i18nPath}.pleaseVisit.text`;
const i18nThisLink: string = `${i18nPath}.thisLink.text`;
const i18nToInstall: string = `${i18nPath}.toInstall.text`;
const i18nCloseBtn: string = `${i18nPath}.closeBtn.text`;
const i18Note: string = `${i18nPath}.pleaseNote.text`;
const i18nWarning: string = `${i18nPath}.warning.text`;

export const ChromeExtensionMissingModal = (): React.ReactElement => {
    const dispatch: Dispatch<SetChromeExtensionMissingVisibleAction> = useDispatch();
    const translate: TranslateFunction = useSelector(selectTranslate);
    const visible: boolean = useSelector(selectIsChromeExtensionMissingVisible);
    const extensionUrl: string = useSelector(selectCtWebExtensionUrl);

    /**
     * Closes modal
     */
    const closeModal = (): void => {
        dispatch(setChromeExtensionMissingVisible(false));
    };

    return (
        <Modal
            visible={visible}
            title={(
                <CtModalHeader
                    title={translate(i18nTitle) as string}
                    icon={<ModalErrorIcon/>}
                    className="df-ct-header-warning"
                />
            )}
            className="df-modal-primary df-ct-modal df-ct-modal-warning"
            okText={translate(i18nCloseBtn)}
            onOk={closeModal}
            closable={false}
            maskClosable={false}
        >
            <div className="df-modal-content">
                <span>
                    {translate(i18nPleaseVisit)}
                    &nbsp;
                    <a
                        href={extensionUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {translate(i18nThisLink)}
                    </a>
                    &nbsp;
                    {translate(i18nToInstall)}
                </span>
                <div className="df-ct-warning">
                    <span><Translate id={i18Note}/></span>
                    <span><Translate id={i18nWarning}/></span>
                </div>
            </div>
        </Modal>
    );
};
